// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query products($filterBy: InputProductsQueryFilter)  {\nproducts(filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  return {
    products: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      shop: shop
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let products = {
    __typename: value$3,
    edges: edges
  };
  return {
    products: products
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectProductKindEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "SPIRITUOUS" ? "SPIRITUOUS" : (
        a === "BEER" ? "BEER" : (
            a === "WINE" ? "WINE" : "SIMPLE"
          )
      )
  };
}

function serializeInputObjectProductColorEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "ORANGE" ? "ORANGE" : (
        a === "RED" ? "RED" : (
            a === "AMBER" ? "AMBER" : (
                a === "DARK" ? "DARK" : (
                    a === "BLACK" ? "BLACK" : (
                        a === "BLOND" ? "BLOND" : (
                            a === "ROSE" ? "ROSE" : "WHITE"
                          )
                      )
                  )
              )
          )
      )
  };
}

function serializeInputObjectInputProductsQueryFilter(inp) {
  let a = inp.name;
  let a$1 = inp.kind;
  let a$2 = inp.producer;
  let a$3 = inp.color;
  let a$4 = inp.variantCkus;
  let a$5 = inp.shopIds;
  let a$6 = inp.archived;
  return {
    name: a !== undefined ? ({
        _equals: a._equals
      }) : undefined,
    kind: a$1 !== undefined ? serializeInputObjectProductKindEqualsFilter(a$1) : undefined,
    producer: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    color: a$3 !== undefined ? serializeInputObjectProductColorEqualsFilter(a$3) : undefined,
    variantCkus: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    shopIds: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    archived: a$6 !== undefined ? (
        a$6 === "ONLY" ? "ONLY" : (
            a$6 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputProductsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsQueryFilter(name, kind, producer, color, variantCkus, shopIds, archived, param) {
  return {
    name: name,
    kind: kind,
    producer: producer,
    color: color,
    variantCkus: variantCkus,
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductKindEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductColorEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let ProductsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let ProductsQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductsQuery_use = include.use;

let ProductsQuery_useLazy = include.useLazy;

let ProductsQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductsQuery = {
  ProductsQuery_inner: ProductsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ProductsQuery_refetchQueryDescription,
  use: ProductsQuery_use,
  useLazy: ProductsQuery_useLazy,
  useLazyWithVariables: ProductsQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query variantsByCku($cku: CKU!, $filterBy: InputVariantsByCkuQueryFilter)  {\nvariantsByCku(cku: $cku, first: 1, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nname  \ncapacityUnit  \ncapacityValue  \ncapacityPrecision  \nean13  \nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \nalcoholVolume  \nyear  \nbulk  \npurchasedPrice  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nproduct  {\n__typename  \nkind  \n}\n\nvariantPrices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvalueIncludingTax  \nvalueExcludingTax  \nprice  {\n__typename  \nname  \nenableByDefault  \ntaxIncluded  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.capacityUnit;
        let value$3 = value$1.capacityValue;
        let value$4 = value$1.capacityPrecision;
        let value$5 = value$1.ean13;
        let value$6 = value$1.stockKeepingUnit;
        let value$7 = value$1.priceLookUpCode;
        let value$8 = value$1.internalCode;
        let value$9 = value$1.alcoholVolume;
        let value$10 = value$1.year;
        let value$11 = value$1.bulk;
        let value$12 = value$1.purchasedPrice;
        let value$13 = value$1.maxStockThreshold;
        let value$14 = value$1.minStockThreshold;
        let value$15 = value$1.stockOrderTriggerThreshold;
        let value$16 = value$1.product;
        let value$17 = value$16.kind;
        let tmp;
        switch (value$17) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$18 = value$1.variantPrices;
        let value$19 = value$18.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName,
            name: value$1.name,
            capacityUnit: !(value$2 == null) ? value$2 : undefined,
            capacityValue: !(value$3 == null) ? value$3 : undefined,
            capacityPrecision: !(value$4 == null) ? value$4 : undefined,
            ean13: !(value$5 == null) ? value$5 : undefined,
            stockKeepingUnit: !(value$6 == null) ? value$6 : undefined,
            priceLookUpCode: !(value$7 == null) ? value$7 : undefined,
            internalCode: !(value$8 == null) ? value$8 : undefined,
            alcoholVolume: !(value$9 == null) ? value$9 : undefined,
            year: !(value$10 == null) ? value$10 : undefined,
            bulk: !(value$11 == null) ? value$11 : undefined,
            purchasedPrice: !(value$12 == null) ? value$12 : undefined,
            maxStockThreshold: !(value$13 == null) ? value$13 : undefined,
            minStockThreshold: !(value$14 == null) ? value$14 : undefined,
            stockOrderTriggerThreshold: !(value$15 == null) ? value$15 : undefined,
            product: {
              __typename: value$16.__typename,
              kind: tmp
            },
            variantPrices: {
              __typename: value$18.__typename,
              edges: value$19.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.price;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    id: value$1.id,
                    valueIncludingTax: value$1.valueIncludingTax,
                    valueExcludingTax: value$1.valueExcludingTax,
                    price: !(value$2 == null) ? ({
                        __typename: value$2.__typename,
                        name: value$2.name,
                        enableByDefault: value$2.enableByDefault,
                        taxIncluded: value$2.taxIncluded
                      }) : undefined
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variantPrices;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.price;
      let price;
      if (value$2 !== undefined) {
        let value$3 = value$2.taxIncluded;
        let value$4 = value$2.enableByDefault;
        let value$5 = value$2.name;
        let value$6 = value$2.__typename;
        price = {
          __typename: value$6,
          name: value$5,
          enableByDefault: value$4,
          taxIncluded: value$3
        };
      } else {
        price = null;
      }
      let value$7 = value$1.valueExcludingTax;
      let value$8 = value$1.valueIncludingTax;
      let value$9 = value$1.id;
      let value$10 = value$1.__typename;
      let node = {
        __typename: value$10,
        id: value$9,
        valueIncludingTax: value$8,
        valueExcludingTax: value$7,
        price: price
      };
      let value$11 = value.__typename;
      return {
        __typename: value$11,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variantPrices = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.product;
    let value$6 = value$5.kind;
    let kind = value$6 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$6 === "BEER" ? "BEER" : (
            value$6 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$7 = value$5.__typename;
    let product = {
      __typename: value$7,
      kind: kind
    };
    let value$8 = value$1.stockOrderTriggerThreshold;
    let stockOrderTriggerThreshold = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.minStockThreshold;
    let minStockThreshold = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.maxStockThreshold;
    let maxStockThreshold = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.purchasedPrice;
    let purchasedPrice = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.bulk;
    let bulk = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.year;
    let year = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.alcoholVolume;
    let alcoholVolume = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.internalCode;
    let internalCode = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.priceLookUpCode;
    let priceLookUpCode = value$16 !== undefined ? value$16 : null;
    let value$17 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$17 !== undefined ? value$17 : null;
    let value$18 = value$1.ean13;
    let ean13 = value$18 !== undefined ? value$18 : null;
    let value$19 = value$1.capacityPrecision;
    let capacityPrecision = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.capacityValue;
    let capacityValue = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.capacityUnit;
    let capacityUnit = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.name;
    let value$23 = value$1.formattedName;
    let value$24 = value$1.id;
    let value$25 = value$1.__typename;
    let node = {
      __typename: value$25,
      id: value$24,
      formattedName: value$23,
      name: value$22,
      capacityUnit: capacityUnit,
      capacityValue: capacityValue,
      capacityPrecision: capacityPrecision,
      ean13: ean13,
      stockKeepingUnit: stockKeepingUnit,
      priceLookUpCode: priceLookUpCode,
      internalCode: internalCode,
      alcoholVolume: alcoholVolume,
      year: year,
      bulk: bulk,
      purchasedPrice: purchasedPrice,
      maxStockThreshold: maxStockThreshold,
      minStockThreshold: minStockThreshold,
      stockOrderTriggerThreshold: stockOrderTriggerThreshold,
      product: product,
      variantPrices: variantPrices
    };
    let value$26 = value.__typename;
    return {
      __typename: value$26,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputVariantsByCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.active;
  let a$2 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    active: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    archived: a$2 !== undefined ? (
        a$2 === "ONLY" ? "ONLY" : (
            a$2 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables$1(inp) {
  let a = inp.filterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputVariantsByCkuQueryFilter(a) : undefined
  };
}

function makeVariables$1(cku, filterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsByCkuQueryFilter(shopIds, active, archived, param) {
  return {
    shopIds: shopIds,
    active: active,
    archived: archived
  };
}

function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

let VariantQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let VariantQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let VariantQuery_use = include$1.use;

let VariantQuery_useLazy = include$1.useLazy;

let VariantQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let VariantQuery = {
  VariantQuery_inner: VariantQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  refetchQueryDescription: VariantQuery_refetchQueryDescription,
  use: VariantQuery_use,
  useLazy: VariantQuery_useLazy,
  useLazyWithVariables: VariantQuery_useLazyWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["query productsByVariantCku($cku: CKU!, $filterBy: InputProductsByVariantCkuQueryFilter)  {\nproductsByVariantCku(cku: $cku, first: 1, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nkind  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  return {
    productsByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.kind;
        let tmp;
        switch (value$2) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.tax;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            kind: tmp,
            tax: {
              __typename: value$3.__typename,
              value: value$3.value
            }
          }
        };
      })
    }
  };
}

function serialize$2(value) {
  let value$1 = value.productsByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.tax;
    let value$3 = value$2.value;
    let value$4 = value$2.__typename;
    let tax = {
      __typename: value$4,
      value: value$3
    };
    let value$5 = value$1.kind;
    let kind = value$5 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$5 === "BEER" ? "BEER" : (
            value$5 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$6 = value$1.name;
    let value$7 = value$1.id;
    let value$8 = value$1.__typename;
    let node = {
      __typename: value$8,
      id: value$7,
      name: value$6,
      kind: kind,
      tax: tax
    };
    let value$9 = value.__typename;
    return {
      __typename: value$9,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let productsByVariantCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    productsByVariantCku: productsByVariantCku
  };
}

function serializeInputObjectInFilter$2(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputProductsByVariantCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$2(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables$2(inp) {
  let a = inp.filterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputProductsByVariantCkuQueryFilter(a) : undefined
  };
}

function makeVariables$2(cku, filterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsByVariantCkuQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectInFilter$2(_in, param) {
  return {
    _in: _in
  };
}

let ProductQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  makeVariables: makeVariables$2,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2
};

let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let ProductQuery_refetchQueryDescription = include$2.refetchQueryDescription;

let ProductQuery_use = include$2.use;

let ProductQuery_useLazy = include$2.useLazy;

let ProductQuery_useLazyWithVariables = include$2.useLazyWithVariables;

let ProductQuery = {
  ProductQuery_inner: ProductQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputProductsByVariantCkuQueryFilter: serializeInputObjectInputProductsByVariantCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  makeVariables: makeVariables$2,
  makeInputObjectInputProductsByVariantCkuQueryFilter: makeInputObjectInputProductsByVariantCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2,
  refetchQueryDescription: ProductQuery_refetchQueryDescription,
  use: ProductQuery_use,
  useLazy: ProductQuery_useLazy,
  useLazyWithVariables: ProductQuery_useLazyWithVariables
};

export {
  ProductsQuery,
  VariantQuery,
  ProductQuery,
}
/* query Not a pure module */
